import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

// This reducer should be generic enough to be used for any filters
// Programs, Activities, Courses, possibly Classrooms can be refactored to use it
export const setIsFilteredReducer = (state, payload) => {
  const isFiltered = payload.payload
  const newState = {
    ...state,
    isFiltered
  }
  return newState
}

export const setShowFiltersReducer = (state, payload) => {
  const showFilters = payload.payload

  const newState = {
    ...state,
    showFilters
  }
  return newState
}

export const onSortReducer = (state, { payload }) => {
  const { sortValue } = payload

  const newState = {
    ...state,
    sortValue,
    isSorted: true,
    isFiltered: true
  }
  return newState
}

export const onProductFilterReducer = (state, { payload }) => {
  const { productFilters } = payload
  const newState = {
    ...state,
    productFilters,
    isFiltered: true
  }

  return newState
}

export const onGradeLevelFilterReducer = (state, { payload }) => {
  const { gradeLevels } = payload

  return {
    ...state,
    gradeLevels
  }
}

export const onPageFilterReducer = (state, { payload }) => {
  const { page } = payload
  return {
    ...state,
    page
  }
}

export const onLanguageFilterReducer = (state, { payload }) => {
  const { language } = payload

  return {
    ...state,
    language
  }
}

export const onDurationFilterReducer = (state, { payload }) => {
  const { duration } = payload

  return {
    ...state,
    duration
  }
}

export const onThemesReducer = (state, { payload }) => {
  const { themes } = payload
  return {
    ...state,
    themes
  }
}

export const onStandardsReducer = (state, { payload }) => {
  const { standards } = payload

  return {
    ...state,
    standards
  }
}

export const onProductsReducer = (state, { payload }) => {
  const { products } = payload

  return {
    ...state,
    products
  }
}

export const stackItemsReducer = (state, { payload }) => {
  const { items, isFiltered } = payload

  const newState = {
    ...state,
    items: items,
    loading: false,
    // page: state.page + 1,
    fetchMore: false,
    isFiltered
  }

  return newState
}

export const stackItemsScrollReducer = (state, { payload }) => {
  const { items, isFiltered } = payload
  const newState = {
    ...state,
    items: _.concat(state.items, items),
    loading: false,
    page: state.page + 1,
    fetchMore: false,
    isFiltered
  }

  return newState
}

export const setIsLoadingReducer = (state, { payload }) => {
  const loading = payload

  return {
    ...state,
    loading
  }
}

export const setFetchMoreReducer = (state, { payload }) => {
  const fetchMore = payload

  return {
    ...state,
    fetchMore
  }
}

export const setDoneFetchingReducer = (state) => {
  return {
    ...state,
    doneFetching: true
  }
}

export const resetPagingReducer = (state) => {
  return {
    ...state,
    fetchMore: true,
    page: 1,
    items: [],
    doneFetching: false
  }
}

export const clearFiltersReducer = (state) => {
  const newState = {
    ...state,
    isFiltered: false,
    sortValue: null,
    isSorted: false,
    productFilters: {
      sphero: false,
      littleBits: false
    },
    gradeLevels: null,
    language: '',
    themes: '',
    duration: '',
    standards: '',
    products: '',
    loading: false,
    fetchMore: false,
    dongFetching: false,
    page: 1,
    items: []
  }
  return newState
}

const activitySlice = createSlice({
  name: 'filters',
  initialState: {
    showFilters: false,
    isFiltered: false,
    sortValue: null,
    isSorted: false,
    productFilters: {
      sphero: false,
      littleBits: false
    },
    gradeLevels: null,
    language: '',
    themes: '',
    duration: '',
    standards: '',
    products: '',
    items: [],
    loading: false,
    fetchMore: false,
    dongFetching: false,
    page: 1
  },
  reducers: {
    setIsFiltered: setIsFilteredReducer,
    setShowFilters: setShowFiltersReducer,
    onSort: onSortReducer,
    onProductFilter: onProductFilterReducer,
    onGradeLevelFilter: onGradeLevelFilterReducer,
    onLanguageFilter: onLanguageFilterReducer,
    clearFilters: clearFiltersReducer,
    stackItems: stackItemsReducer,
    stackScrollItems: stackItemsScrollReducer,
    setIsLoading: setIsLoadingReducer,
    setFetchMore: setFetchMoreReducer,
    setDoneFetching: setDoneFetchingReducer,
    resetPaging: resetPagingReducer,
    setPaging: onPageFilterReducer,
    onDurationFilter: onDurationFilterReducer,
    onThemesFilter: onThemesReducer,
    onStandardsFilter: onStandardsReducer,
    onProductsFilter: onProductsReducer
  }
})

const { actions, reducer } = activitySlice

export const {
  setIsFiltered,
  setShowFilters,
  onSort,
  onProductFilter,
  onGradeLevelFilter,
  onLanguageFilter,
  clearFilters,
  stackItems,
  stackScrollItems,
  setIsLoading,
  setFetchMore,
  setDoneFetching,
  resetPaging,
  setPaging,
  onDurationFilter,
  onThemesFilter,
  onStandardsFilter,
  onProductsFilter
} = actions

export default reducer
